import { useEffect, useRef } from 'react';

import { track } from '@/lib/track';

/**
 * Reports each render the visitor watched finish (`ready` or `failed`) exactly
 * once. Renders already finished when the page loaded are never reported, so
 * the count reflects renders that started in this session.
 */
export function useRenderOutcomeTracking(slug: string, items: readonly { id: string; state: string }[]): void {
  const watching = useRef(new Set<string>());
  useEffect(() => {
    for (const item of items) {
      if (item.state === 'rendering') watching.current.add(item.id);
      else if (watching.current.delete(item.id)) track('tool_render_finished', { tool: slug, state: item.state });
    }
  }, [items, slug]);
}
